<div class="tw-w-full tw-p-4 tw-bg-white tw-mb-4 tw-shadow-z1">
  <div class="tw-w-full tw-flex tw-gap-2 tw-justify-start tw-items-center tw-mb-4">
    <img [src]="allocatedDoctorImage" class="tw-w-12" alt="Doctor" />
    <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-font-lexend">
      <h1 class="tw-text-300 tw-font-extrabold">WHAT WE'LL DO NEXT?</h1>
      <p class="tw-text-200 tw-font-light tw-text-teal-700">Let's go through your personalized plan</p>
    </div>
  </div>
  <div class="tw-w-full tw-bg-gray-100 tw-py-4 tw-px-3 tw-rounded-2.5 tw-mb-4">
    <div class="tw-w-full tw-mb-3 tw-flex tw-items-start tw-gap-2 tw-font-lexend">
      <div class="tw-pt-0.5">
        <svg class="tw-w-4 tw-h-fit" width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 12L10 18L20 6"
                stroke="black"
                stroke-width="3"
                stroke-linecap="butt"
                stroke-linejoin="miter"/>
        </svg>
      </div>
      <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.5">
        <h1 class=" tw-text-300 tw-font-bold">Target your {{ concernName }}</h1>
        <p class=" tw-text-200 tw-font-light tw-leading-[17px] tw-mb-0.5">Repair cream with ingredients like</p>
        <div class="tw-w-fit tw-flex tw-items-center tw-justify-start tw-gap-1">
          @for (ingredient of repairIngredients; track ingredient.objectId) {
            <div class="tw-px-2 tw-py-1 tw-bg-white tw-shadow-z1 tw-rounded-[5px] tw-text-200 tw-text-teal-700 tw-font-body tw-font-normal tw-flex tw-items-center tw-gap-1">
              <img [src]="ingredient.image" class="tw-w-4 tw-h-4 tw-object-contain" alt="" />
              {{ ingredient.name }}
            </div>
          }
        </div>
      </div>
    </div>
    <div class="tw-w-full tw-mb-3 tw-flex tw-items-start tw-gap-2 tw-font-lexend">
      <div class="tw-pt-0.5">
        <svg class="tw-w-4 tw-h-fit" width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 12L10 18L20 6"
                stroke="black"
                stroke-width="3"
                stroke-linecap="butt"
                stroke-linejoin="miter"/>
        </svg>
      </div>
      <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.5">
        <h1 class=" tw-text-300 tw-font-bold">Daily skincare routine</h1>
        <ul class="tw-text-200 tw-font-light tw-leading-[17px] tw-list-disc tw-pl-5">
          @if (facewashSentence) {
            <li>{{ facewashSentence }}</li>
          }
          <li>Sunscreen with advanced UV filters</li>
          <li>Moisturiser to rebuild your skin barrier</li>
        </ul>
      </div>
    </div>
    @if (supplementDescription) {
      <div class="tw-w-full tw-flex tw-items-start tw-gap-2 tw-font-lexend">
        <div class="tw-pt-0.5">
          <svg class="tw-w-4 tw-h-fit" width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 12L10 18L20 6"
                  stroke="black"
                  stroke-width="3"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"/>
          </svg>
        </div>
        <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.5">
          <h1 class=" tw-text-300 tw-font-bold">Supplements (Optional)</h1>
          <p class=" tw-text-200 tw-font-light tw-leading-[17px]">{{ supplementDescription }}</p>
        </div>
      </div>
    }
  </div>
  <div class="tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-2.5">
    <svg class="tw-w-[18px] tw-h-fit tw-ml-2" width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="5" width="18" height="16" rx="2"
            stroke="#6B6B6B"
            stroke-width="2"/>

      <line x1="3" y1="10.5" x2="21" y2="10.5"
            stroke="#6B6B6B"
            stroke-width="2"/>

      <line x1="8" y1="3" x2="8" y2="7"
            stroke="#6B6B6B"
            stroke-width="2"
            stroke-linecap="round"/>

      <line x1="16" y1="3" x2="16" y2="7"
            stroke="#6B6B6B"
            stroke-width="2"
            stroke-linecap="round"/>
    </svg>
    <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-font-lexend">
      <h1 class="tw-text-300 tw-font-extrabold tw-text-teal-500 tw-leading-4">Doctor Checkup: <span class="tw-font-normal">After 2 weeks</span></h1>
      <p class="tw-text-200 tw-font-light tw-text-teal-700">We will check your skin improvement.</p>
    </div>
  </div>
</div>
